import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const DeleteProjectModal = ({
  project,
  open,
  onClose,
  onConfirm,
  deleting,
  error,
}) => {
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (open) {
      setConfirmText("");
    }
  }, [open, project?.hash]);

  if (!open || !project) {
    return null;
  }

  const expected = `delete ${project.name}`;
  const matches = confirmText === expected;

  return createPortal(
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg border border-theme-secondary bg-theme-main p-6">
        <h3 className="mb-2 text-lg font-semibold text-theme-text">
          Delete project permanently?
        </h3>
        <p className="mb-4 text-sm text-theme-text opacity-70">
          This permanently deletes your project data, removes the live site, and
          deletes the GitHub repository. This cannot be undone.
        </p>
        <label
          htmlFor="delete_confirm_text"
          className="mb-2 block text-sm text-theme-text opacity-70"
        >
          Type{" "}
          <code className="rounded bg-theme-secondary px-1.5 py-0.5 font-mono text-[13px] text-theme-text">
            {expected}
          </code>{" "}
          to confirm
        </label>
        <input
          id="delete_confirm_text"
          type="text"
          value={confirmText}
          onChange={(event) => setConfirmText(event.target.value)}
          disabled={deleting}
          autoComplete="off"
          spellCheck={false}
          className="mb-4 block w-full appearance-none rounded-md border border-theme-secondary px-3 py-2 font-mono text-sm text-theme-text shadow-sm placeholder-opacity-60 focus:border-theme-primary focus:outline-none focus:ring-theme-primary disabled:opacity-60"
        />
        {error && (
          <div className="mb-4 rounded border border-red-500 bg-red-500/20 p-3 text-sm text-theme-text">
            {error}
          </div>
        )}
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={onClose}
            disabled={deleting}
            className="flex-1 rounded-md border border-theme-secondary px-4 py-2 text-theme-text hover:bg-theme-secondary focus:outline-none focus:ring-2 focus:ring-theme-primary disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(expected)}
            disabled={deleting || !matches}
            className="flex-1 rounded-md bg-red-600 px-4 py-2 text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50"
          >
            {deleting ? "Deleting..." : "Delete forever"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteProjectModal;
